import { render, staticRenderFns } from "./AppTopbarLinkGroup.vue?vue&type=template&id=6dcfe51a&"
import script from "./AppTopbarLinkGroup.vue?vue&type=script&lang=js&"
export * from "./AppTopbarLinkGroup.vue?vue&type=script&lang=js&"
import style0 from "./AppTopbarLinkGroup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports